export const shirtSizeOptions = ['SM', 'MD', 'LG', 'XL', '2XL', '3XL'];
